
import { useState, useRef, useCallback } from "react";

/**
 * Hook for managing batch processing state
 */
export const useBatchProcessingState = () => {
  const [isBatchProcessing, setIsBatchProcessing] = useState(false);
  const pendingSaves = useRef<{investor: any, timestamp: number}[]>([]);
  const saveTimerRef = useRef<number | null>(null);
  
  /**
   * Start batch processing mode
   */
  const startBatchProcessing = useCallback(() => {
    console.log("Starting batch processing mode");
    setIsBatchProcessing(true);
    pendingSaves.current = [];
  }, []);
  
  /**
   * End batch processing mode
   */
  const endBatchProcessing = useCallback(async () => {
    console.log("Ending batch processing mode, flushing pending saves");
    setIsBatchProcessing(false);
    
    // Clear any pending save timer
    if (saveTimerRef.current) {
      clearTimeout(saveTimerRef.current);
      saveTimerRef.current = null;
    }
    
    return true;
  }, []);
  
  /**
   * Check if sync is disabled - always returns false now
   */
  const isSyncDisabled = useCallback(() => {
    return false; // Always allow sync
  }, []);
  
  /**
   * Add investor to pending saves
   */
  const addToPendingSaves = useCallback((investor: any) => {
    pendingSaves.current.push({
      investor,
      timestamp: Date.now()
    });
    
    console.log(`Added investor ${investor.id} to pending saves queue (total: ${pendingSaves.current.length})`);
    
    return pendingSaves.current.length;
  }, []);
  
  /**
   * Count pending saves
   */
  const pendingCount = useCallback(() => pendingSaves.current.length, []);
  
  return {
    isBatchProcessing,
    pendingSaves,
    saveTimerRef,
    startBatchProcessing,
    endBatchProcessing,
    isSyncDisabled,
    addToPendingSaves,
    pendingCount
  };
};
